import type { RouteLanguageCode } from '../utils/languageRouting';

export type AwardPosterCopy = {
  brand: string;
  title: string;
  subtitle: string;
  tagline: string;
  openLabel: string;
  closeLabel: string;
};

export const AWARD_POSTER_BACKGROUND = '/img/news/glg-award-2026-background.webp';
export const ORIGINAL_AWARD_POSTER = '/img/news/glg-asia-pacific-award-2026.webp';

export const homeAwardPoster: Record<RouteLanguageCode, AwardPosterCopy> = {
  hk: {
    brand: '金利寶環球',
    title: '亞太黃金交易領軍品牌',
    subtitle: 'Excellence in Precious Metals Trading Services',
    tagline: 'Golden Trust. Global Wealth.',
    openLabel: '閱讀得獎新聞全文',
    closeLabel: '關閉得獎新聞',
  },
  cn: {
    brand: '金利宝环球',
    title: '亚太黄金交易领军品牌',
    subtitle: '卓越的贵金属交易服务',
    tagline: '黄金般的信赖，全球化的财富。',
    openLabel: '阅读获奖新闻全文',
    closeLabel: '关闭获奖新闻',
  },
  en: {
    brand: 'Gold Label Global',
    title: 'Asia-Pacific Leading Gold Trading Brand',
    subtitle: 'Excellence in Precious Metals Trading Services',
    tagline: 'Golden Trust. Global Wealth.',
    openLabel: 'Read the full award news',
    closeLabel: 'Close award news',
  },
  jp: {
    brand: 'Gold Label Global',
    title: 'アジア太平洋の金取引を牽引するブランド',
    subtitle: '貴金属取引サービスにおける卓越性',
    tagline: '黄金の信頼。世界へ広がる豊かさ。',
    openLabel: '受賞ニュースの全文を読む',
    closeLabel: '受賞ニュースを閉じる',
  },
  kr: {
    brand: 'Gold Label Global',
    title: '아시아·태평양 금 거래 선도 브랜드',
    subtitle: '귀금속 거래 서비스의 탁월함',
    tagline: '황금빛 신뢰. 세계의 풍요.',
    openLabel: '수상 소식 전문 읽기',
    closeLabel: '수상 소식 닫기',
  },
  th: {
    brand: 'Gold Label Global',
    title: 'แบรนด์ชั้นนำด้านการซื้อขายทองคำในเอเชียแปซิฟิก',
    subtitle: 'ความเป็นเลิศด้านบริการซื้อขายโลหะมีค่า',
    tagline: 'ความเชื่อมั่นดั่งทองคำ ความมั่งคั่งระดับโลก',
    openLabel: 'อ่านข่าวการรับรางวัลฉบับเต็ม',
    closeLabel: 'ปิดข่าวการรับรางวัล',
  },
  vn: {
    brand: 'Gold Label Global',
    title: 'Thương hiệu hàng đầu về giao dịch vàng tại Châu Á – Thái Bình Dương',
    subtitle: 'Dịch vụ giao dịch kim loại quý xuất sắc',
    tagline: 'Niềm tin vàng. Thịnh vượng toàn cầu.',
    openLabel: 'Đọc toàn bộ tin nhận giải thưởng',
    closeLabel: 'Đóng tin nhận giải thưởng',
  },
  de: {
    brand: 'Gold Label Global',
    title: 'Führende Marke für Goldhandel im asiatisch-pazifischen Raum',
    subtitle: 'Exzellente Dienstleistungen im Edelmetallhandel',
    tagline: 'Goldenes Vertrauen. Weltweiter Wohlstand.',
    openLabel: 'Vollständige Nachricht zur Auszeichnung lesen',
    closeLabel: 'Nachricht zur Auszeichnung schließen',
  },
  fr: {
    brand: 'Gold Label Global',
    title: 'Marque leader du trading d’or en Asie-Pacifique',
    subtitle: 'Excellence des services de trading de métaux précieux',
    tagline: 'Une confiance en or. Une prospérité mondiale.',
    openLabel: 'Lire l’intégralité de l’annonce du prix',
    closeLabel: 'Fermer l’annonce du prix',
  },
  it: {
    brand: 'Gold Label Global',
    title: 'Marchio leader nel trading dell’oro nell’Asia-Pacifico',
    subtitle: 'Eccellenza nei servizi di trading di metalli preziosi',
    tagline: 'Fiducia d’oro. Prosperità globale.',
    openLabel: 'Leggi la notizia completa sul premio',
    closeLabel: 'Chiudi la notizia sul premio',
  },
  es: {
    brand: 'Gold Label Global',
    title: 'Marca líder en negociación de oro en Asia-Pacífico',
    subtitle: 'Excelencia en servicios de negociación de metales preciosos',
    tagline: 'Confianza de oro. Prosperidad global.',
    openLabel: 'Leer la noticia completa del premio',
    closeLabel: 'Cerrar la noticia del premio',
  },
  ug: {
    brand: 'Gold Label Global',
    title: 'ئاسىيا-تىنچ ئوكياندىكى ئالتۇن سودىسىنىڭ باشلامچى ماركىسى',
    subtitle: 'قىممەتلىك مېتال سودا مۇلازىمىتىدىكى مۇنەۋۋەرلىك',
    tagline: 'ئالتۇندەك ئىشەنچ. دۇنياۋى بايلىق.',
    openLabel: 'مۇكاپات خەۋىرىنىڭ تولۇق تېكىستىنى ئوقۇش',
    closeLabel: 'مۇكاپات خەۋىرىنى تاقاش',
  },
};
